import _ from "../../config/Constants";

export default _;
